import { FiPlus, FiMinus } from "react-icons/fi";

export default function FaqItem({ faq, open, onToggle }) {
    return (
        <details
            className={`faq-item ${open ? "open" : ""}`}
            open={open}
            onClick={(e) => {
                e.preventDefault();
                onToggle();
            }}
        >
            <summary>
                <span>{faq.question}</span>
                <span className="faq-icon-wrapper">
                    {open ? (
                        <FiMinus className="faq-icon minus" />
                    ) : (
                        <FiPlus className="faq-icon plus" />
                    )}
                </span>
            </summary>

            <p className="ans_">{faq.answer}</p>
        </details>
    );
}
